import {useCallback, useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonShapes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import FormContactSeller from '@adv-mt/mt-form-contact-seller'
import LeadPhoneCall, {leadPhoneCallColors, leadPhoneCallDesigns, leadPhoneCallSizes} from '@adv-mt/mt-lead-phone-call'
import ModalBasic, {moleculeModalSizes} from '@adv-mt/mt-modal-basic'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

const CardAdContact = ({
  ad,
  color = atomButtonColors.ACCENT,
  design,
  emailLeadType,
  emailListType,
  extendedTrackingData,
  multiprovince,
  pageName,
  target
}) => {
  const [leadData, setLeadData] = useState()
  const [isSellerBlocked, setIsSellerBlocked] = useState(false)
  const sellerId = ad?.seller?.sellerMessagingId

  const {domain} = useContext(Context)

  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {OFFER_TYPE_SECOND_HAND, OFFER_TYPE_KM0, OFFER_TYPE_NEW, DEFAULT_CATEGORY1_ID} = config.get('search')

  const isVOorVNorKM0 =
    [OFFER_TYPE_SECOND_HAND, OFFER_TYPE_KM0, OFFER_TYPE_NEW].includes(ad?.offerType?.id) &&
    [DEFAULT_CATEGORY1_ID].includes(ad?.category1Id)

  useMount(async () => {
    const [, _leadData] = await domain.get('get_lead_data_tracking_use_case').execute({
      ad,
      dealerId: ad?.seller?.contractId,
      product: extendedTrackingData?.product,
      filters: extendedTrackingData?.filters
    })
    setLeadData(_leadData)
  })

  const handleContactByMail = useCallback(
    ({messageContactId} = {}) => {
      track({
        event: 'Lead Triggered',
        data: {
          lead_type: emailLeadType || config.get('tracking').LEAD_TYPES.DETAIL_AD_REPLIED_EMAIL,
          hit_information3: messageContactId,
          ...(emailListType && {list_type: emailListType}),
          ...leadData
        }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [leadData]
  )

  const getBlockedSellers = async () => {
    // get_blocked_sellers_use_case --> change name
    const blockedSellers = await domain.get('parse_blocked_user_cookies_use_case').execute()
    const isUserBlocked = blockedSellers?.isUserBlocked?.(String(sellerId)) || false
    setIsSellerBlocked(isUserBlocked)
  }

  useMount(() => {
    getBlockedSellers()
  })

  return (
    <ModalBasic
      openTrigger={
        <AtomButton color={color} design={design} fullWidth shape={atomButtonShapes.CIRCULAR}>
          Contactar
        </AtomButton>
      }
      size={moleculeModalSizes.MEDIUM}
      title="Contacta con el anunciante"
    >
      <FormContactSeller
        ad={ad}
        adId={ad.id}
        buttonCallSeller={
          !ad.hidePhone && (
            <LeadPhoneCall
              adId={ad.id}
              color={leadPhoneCallColors.PRIMARY}
              contractId={ad.seller?.contractId}
              design={leadPhoneCallDesigns.OUTLINE}
              extendedLeadTrackingData={leadData}
              hasCriteoEvents
              multiprovince={multiprovince}
              phone={ad.phone}
              size={leadPhoneCallSizes.large}
              target={target}
            />
          )
        }
        contractId={ad.seller?.contractId}
        enableLeadEnrichment={isVOorVNorKM0}
        isModal={true}
        isSellerBlocked={isSellerBlocked}
        onContact={handleContactByMail}
        pageName={pageName}
        province={multiprovince}
        sellerId={sellerId}
        showLabels={false}
        showSellerCallLinkButton={false}
      />
    </ModalBasic>
  )
}

CardAdContact.displayName = 'CardAdContact'

CardAdContact.propTypes = {
  ad: PropTypes.object,
  color: PropTypes.string,
  design: PropTypes.string,
  emailLeadType: PropTypes.string,
  emailListType: PropTypes.string,
  extendedTrackingData: PropTypes.object,
  multiprovince: PropTypes.string,
  pageName: PropTypes.string,
  target: PropTypes.string
}

export default CardAdContact
